module.exports = __webpack_public_path__ + "static/media/hand-point-up.da5e9870.svg";